import {
  getArrayTags,
  getBooleanTags,
  getDateTags,
  getFlagTags,
  getRangeTags,
  getGroupedTags,
  type IFilterTag,
  type ITagExtractorContext,
} from '@/creditflowresearch/ui/common/components/FilterTags';
import type { TFilterPayload } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilter';
import type { ICorporateBondScreenerFilterBoundaries } from '@/creditflowresearch/domain/vo/Bondscreener';
import { getTodayDate } from '@/creditflowresearch/application/BondScreener/getTodayDate';
import {
  arrayConfigs, booleanConfigs, dateConfigs, flagConfigs, groupedConfigs, rangeConfigs,
} from './corporateFilterTagConfigs';

const buildCorporateFilterTags = (
  { filters, boundaries }: ITagExtractorContext<TFilterPayload, ICorporateBondScreenerFilterBoundaries>,
): IFilterTag[] => {
  const localBoundaries: ICorporateBondScreenerFilterBoundaries | null = boundaries && {
    ...boundaries,
    date: boundaries.date && { ...boundaries.date, to: getTodayDate() },
  };

  return [
    ...getGroupedTags(groupedConfigs, filters),
    ...getArrayTags(arrayConfigs, filters),
    ...getRangeTags(rangeConfigs, filters, localBoundaries),
    ...getDateTags(dateConfigs, filters, localBoundaries),
    ...getBooleanTags(booleanConfigs, filters),
    ...getFlagTags(flagConfigs, filters),
  ];
};

export default buildCorporateFilterTags;
